import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { DESKTOP_NAV_LINKS } from "@/components/layout/navItems";

export const NavLinks = () => (
  <div className="hidden flex-1 items-center justify-center gap-4 xl:flex 2xl:gap-6">
    {DESKTOP_NAV_LINKS.map((l) => (
      <NavLink
        key={l.to}
        to={l.to}
        end={l.end}
        data-testid={l.testId}
        className={({ isActive }) =>
          cn(
            "whitespace-nowrap text-sm font-medium transition-colors",
            isActive ? "text-white" : "text-white/75 hover:text-white"
          )
        }
      >
        {l.label}
      </NavLink>
    ))}
  </div>
);

export default NavLinks;
